import { useEffect, useState } from "react";
import { SECURITY_UI_URL } from "../../constants/config.constant";

export function useIFrameWindow() {
    const [iframeWindow, setIframeWindow] = useState<Window | null>(null);

    useEffect(() => {
        let iframe = document.getElementById("post-message-iframe") as HTMLIFrameElement | null;

        if (!iframe) {
            iframe = document.createElement("iframe");

            iframe.src = `${SECURITY_UI_URL}/post_message_to_frame_owner.html`;
            iframe.id = "post-message-iframe";

            // iOS-safe hidden style
            iframe.style.position = "absolute";
            iframe.style.left = "-9999px";
            iframe.style.width = "1px";
            iframe.style.height = "1px";
            iframe.style.opacity = "0.01";
            iframe.style.border = "none";

            // optional sandbox for cross-origin safety
            iframe.setAttribute("sandbox", "allow-scripts allow-same-origin");

            iframe.onload = () => {
                setTimeout(() => {
                    if (iframe?.contentWindow) {
                        setIframeWindow(iframe.contentWindow);
                    }
                }, 100);
            };

            document.body.appendChild(iframe);
        } else {
            if (iframe.contentWindow) {
                setIframeWindow(iframe.contentWindow);
            }
        }

        return () => {
            // optional cleanup if needed
            // iframe?.remove();
        };
    }, []);

    return { iframeWindow };
}
